import { openModal } from '@core/components/ModalStack';
import { AddEditTaskModalProps } from './AddEditTaskModal';

export async function openAddEditTaskModal(props: AddEditTaskModalProps) {
  const { AddEditTaskModal } = await import('./AddEditTaskModal');

  openModal(AddEditTaskModal, props);
}
